export default __webpack_public_path__ + "static/media/luminous.755f9c14.png";